import type { TemplateAssociations } from "@amzn/d16-g-cdb-publisher-portal-typescript-client";
import { has } from "lodash";

import type { OnDemandDecksFilterFieldSelections } from "../types/filters/onDemandDeckTemplates";
import { OnDemandDecksFilterField } from "../types/filters/onDemandDeckTemplates";

import type { FilterOptionsMap } from "./filters.utils";
import { fieldIncludesSearchQuery } from "./insightPackages.utils";

export type OnDemandInsightFilters = {
    [OnDemandDecksFilterField.TOPIC]: FilterOptionsMap;
    [OnDemandDecksFilterField.LANGUAGE]: FilterOptionsMap;
};

export const generateOnDemandInsightsFilterOptions = (
    insights: TemplateAssociations[],
): OnDemandInsightFilters => {
    const filters: OnDemandInsightFilters = {
        [OnDemandDecksFilterField.TOPIC]: {},
        [OnDemandDecksFilterField.LANGUAGE]: {},
    };

    insights.forEach((insight: TemplateAssociations) => {
        const { language, program } = insight;

        if (program) {
            if (program.id && program.name && !has(filters.TOPIC, program.id)) {
                filters.TOPIC[program.id] = {
                    label: program.name,
                    value: program.id,
                };
            }
        }

        if (language) {
            if (!has(filters.ON_DEMAND_LANGUAGE, language)) {
                filters.ON_DEMAND_LANGUAGE[language] = {
                    label: language,
                    value: language,
                };
            }
        }
    });

    return filters;
};

export const matchesOnDemandInsightSelections = (
    template: TemplateAssociations,
    fieldSelections: OnDemandDecksFilterFieldSelections,
    searchQuery?: string,
): boolean => {
    const matchesTopic =
        (template.program &&
            template.program.id &&
            fieldSelections.TOPIC.some(
                (topic) => topic.value === template.program?.id,
            )) ||
        fieldSelections.TOPIC.length === 0 ||
        !template.program ||
        !template.program.id ||
        !template.program.name;

    const matchesLanguage =
        (template.language &&
            fieldSelections.ON_DEMAND_LANGUAGE.some(
                (topic) => topic.value === template.language,
            )) ||
        fieldSelections.ON_DEMAND_LANGUAGE.length === 0 ||
        !template.language;

    const matchesSearchQuery =
        !searchQuery ||
        searchQuery.trim() === "" ||
        fieldIncludesSearchQuery(template.program?.name, searchQuery) ||
        fieldIncludesSearchQuery(template.language, searchQuery) ||
        fieldIncludesSearchQuery(template.name, searchQuery);

    return matchesTopic && matchesLanguage && matchesSearchQuery;
};
